import { Button, Paper, Typography, Theme, useTheme, Box } from '@mui/material'
import { SuccessIcon } from '../../assets/SvgIcons'
import { GetCurrentConsentApplicationBody } from '../../redux-store/actions/otpConsent'
import { Stack } from '@mui/system'

function ConsentVerified({ currentApplicationData }: { currentApplicationData: Partial<GetCurrentConsentApplicationBody> }): JSX.Element {
  const theme = useTheme();
  return (
    <Paper
      elevation={3}
      sx={{
        p: 4,
        maxWidth: 600,
        width: '100%',
        borderRadius: '16px',
        textAlign: 'center',
        backgroundColor: 'background.default',
      }}
    >
      <Typography variant="body_500" sx={{ mt: 1, mb: 1, color: 'primary.light', fontWeight: 600 }}>
        Congratulations!
      </Typography>
      <SuccessIcon />
      <Typography
        variant="h2"
        sx={(theme: Theme) => ({
          lineHeight: "25px",
          letterSpacing: "0.01px",
          color: theme.palette.text.primary,
          mb: 2
        })}
      >
        Consent Verification Successful
      </Typography>
      <Box sx={{ width: '100%', display: 'flex', flexDirection: 'row', gap: 1, justifyContent: 'space-between', mb: 2 }}>
        <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
          <Typography variant="body_500" fontWeight={600} color="primary.light" >
            Holder Name:
          </Typography>
          <Typography variant="body_500" fontWeight={500} color="primary.light">
            {currentApplicationData?.name}
          </Typography>
        </Box>
        <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
          <Typography variant="body_500" fontWeight={600} color="primary.light">
            Application Number:
          </Typography>
          <Typography variant="body_500" fontWeight={500} color="primary.light">
            {currentApplicationData?.applicationNumber}
          </Typography>
        </Box>
        <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
          <Typography variant="body_500" fontWeight={600} color="primary.light">
            PAN Number:
          </Typography>
          <Typography variant="body_500" fontWeight={500} color="primary.light">
            {currentApplicationData?.panNo}
          </Typography>
        </Box>
      </Box>
      <Typography
        variant="subtitle_400"
        sx={(theme: Theme) => ({
          lineHeight: "22px",
          letterSpacing: "0.02px",
          color: theme.palette.text.secondary,
          textAlign: "center",
          paddingLeft: "10px",
          paddingRight: "10px",
          mb: 2
        })}
      >
        Your consent has been successfully verified. You will receive further updates from your Relationship Manager (RM) shortly.
      </Typography>
      <Typography
        variant="subtitle_400"
        sx={(theme: Theme) => ({
          lineHeight: "22px",
          letterSpacing: "0.02px",
          color: theme.palette.text.secondary,
          textAlign: "center",
          paddingLeft: "10px",
          paddingRight: "10px",
          mb: 2
        })}
      >
        If you have any questions or concerns, please reach out to your RM.
      </Typography>
      {/* You can close this tab now */}
      <Typography
        variant="subtitle_400"
        sx={(theme: Theme) => ({
          lineHeight: "22px",
          letterSpacing: "0.02px",
          color: theme.palette.text.primary,
          textAlign: "center",
          paddingLeft: "10px",
          paddingRight: "10px"
        })}
      >
        You can close this tab now.
      </Typography>

      {/* <Button
        variant="contained"
        color="primary"
        sx={{ mt: 4, px: 4, py: 1 }}
      >
        Contact RM
      </Button> */}
    </Paper>
  )
}

export default ConsentVerified